import { Link } from "react-router-dom";
import VolumeControl from "./VolumeControl";

export default function Header() {
  return (
    <header className="fixed top-0 left-0 right-0 z-40 flex items-center justify-between px-6 py-4 bg-[#09274d]/95 backdrop-blur-md border-b border-white/5 shadow-lg shadow-black/20">
      <Link to="/" className="flex items-center hover:opacity-90 transition-opacity">
        <img src="/web-app-manifest-192x192.png" alt="VSWORD" className="h-10 w-auto" />
      </Link>
      <nav className="flex items-center gap-4">
        <Link
          to="/leaderboard"
          className="text-sm font-medium text-vsw-200 hover:text-white transition-colors px-3 py-1.5 rounded-md hover:bg-vsw-800"
        >
          Leaderboard
        </Link>
        <VolumeControl />
      </nav>
    </header>
  );
}
